import React from "react";
import {Box, Card} from "@mui/material";

interface Attachment {
    thumbnails: any;
    id: number;
    fileName: string;
    contentUrl: string;
}

interface Comment {
    id: number;
    createdAt: string;
    body: string;
    attachments: Attachment[];
    autherId: number;
}

interface DisplayAttachmentsProps {
    comment: Comment;
}

const DisplayAttachments: React.FC<DisplayAttachmentsProps> = ({
                                                                   comment,
                                                               }) => {
    // Function to check if the attachment is a video
    const isVideoFile = (fileName: string) => {
        return /\.(mp4|mov|avi|mkv|webm)$/i.test(fileName);
    };
    
    let gridClassName = "";
    if (comment.attachments.length > 1) {
     if (comment.autherId === 27730026126609) {
       gridClassName = "grid grid-cols-2 gap-4";
     } else {
       gridClassName = "grid grid-cols-2 direction-rtl gap-4";
     }
    }

    return (
            <Box
                className={gridClassName}
            >
                {comment.attachments.length > 0 &&
                    comment.attachments.map((attachment) => (
                        <Box key={attachment.id} sx={{mt: 1, position: "relative"}}>
                            {/* Check if it's an image or video */}
                            {isVideoFile(attachment.fileName) ? (
                                <Card
                                    onClick={() => {
                                        window.open(attachment.contentUrl, "_blank");
                                    }}
                                    sx={{
                                        position: "relative",
                                        cursor: "pointer",
                                        display: "inline-block",
                                    }}
                                >
                                    <img
                                        src={
                                            attachment?.thumbnails[0]?.contentUrl ??
                                            "/assets/images/FilesIcon.png"
                                        }
                                        alt="Video Thumbnail"
                                        onError={(e) => {
                                            (e.target as HTMLImageElement).src = "/assets/images/FilesIcon.png";
                                          }}
                                        width={100}
                                        height={100}
                                        style={{borderRadius: "8px"}}    
                                    />
                                </Card>
                            ) : (
                                <Card
                                    onClick={() => {
                                        window.open(attachment.contentUrl, "_blank");
                                    }}
                                    sx={{
                                        position: "relative",
                                        cursor: "pointer",
                                        display: "inline-block",
                                    }}
                                >
                                    <img
                                        src={
                                            attachment?.thumbnails[0]?.contentUrl ??
                                            "/assets/images/FilesIcon.png"
                                        }
                                        alt="File Thumbnail"
                                        onError={(e) => {
                                            (e.target as HTMLImageElement).src = "/assets/images/FilesIcon.png";
                                          }}
                                        width={100}
                                        height={100}
                                        style={{
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                        }}
                                    />
                                </Card>
                            )}
                        </Box>
                    ))}
            </Box>
    );
};
export default DisplayAttachments;
